var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"loading"},[_c('p',[_c('img',{attrs:{"src":"/static/v2/match/MANA_content_loading.gif","alt":""}}),_vm._v("\n    "+_vm._s(_vm.$t('global.加载中'))+"...\n  ")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f75c064","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v2/match/loading.vue
// module id = null
// module chunks = 